export const PAY_PLAN_TYPE_OPTIONS = [
    {
        label: 'Old Pay Plan',
        value: 'Old Pay Plan',
    },
    {
        label: 'New Pay Plan',
        value: 'New Pay Plan',
    },
    {
        label: 'New Pay Plan - SC',
        value: 'New Pay Plan - SC',
    },
    {
        label: 'New Pay Plan - TX',
        value: 'New Pay Plan - TX',
    },
];

export const PAY_PLAN_TYPE = {
    OldPayPlan : 'Old Pay Plan',
    NewPayPlan : 'New Pay Plan',
    NewPayPlanSC : 'New Pay Plan - SC',
    NewPayPlanTX : 'New Pay Plan - TX',
};

export const chargeBacksResponse = [
    { id: 1, user: 'Xyz', positiveChargeBack: '', negativeChargeBack: '' },
    { id: 2, user: 'Abc', positiveChargeBack: '', negativeChargeBack: '' }
];